module.exports = __webpack_public_path__ + "static/media/Autodesk University Community Features.508abeba.png";